/**
 * Copilot adoption tracking. Who opened the copilot, from which surface,
 * and who actually talked to it — Utils.mixpanelTrack already stamps the
 * user's email, plan and URL on every event, so each call passes only what
 * is specific to the copilot.
 */
import Utils from "Utils/utils";
import { MP_EVENT } from "Static/constant";

/** drawer = the side panel, page = /copilot, widget = the launcher card. */
export const trackCopilotOpened = (surface, extra = {}) =>
  Utils.mixpanelTrack(MP_EVENT.COPILOT_OPENED, { surface, ...extra });

export const trackCopilotMessage = (surface, mode) =>
  Utils.mixpanelTrack(MP_EVENT.COPILOT_MESSAGE_SENT, { surface, inputMode: mode });

export const trackDictation = surface =>
  Utils.mixpanelTrack(MP_EVENT.COPILOT_VOICE_DICTATION, { surface });

export const trackVoiceStart = (surface, voice) =>
  Utils.mixpanelTrack(MP_EVENT.COPILOT_VOICE_CONVERSATION_STARTED, { surface, voice });

/** endedBy: user (button), voice_command ("stop"), agent (Jev sign-off). */
export const trackVoiceEnd = ({ surface, voice, endedBy, startedAt, turns }) =>
  Utils.mixpanelTrack(MP_EVENT.COPILOT_VOICE_CONVERSATION_ENDED, {
    surface,
    voice,
    endedBy,
    turns,
    durationSec: startedAt ? Math.round((Date.now() - startedAt) / 1000) : 0
  });
